import { Button, Form } from 'antd';
import * as dayjs from 'dayjs';
import React, { FC, useEffect, useState } from 'react';
import { localize } from '/react4xp/mixins/helpers';
import { TRANSPORT_TYPES } from '/react4xp/parts/calc-transport/calc-transport-consts';
import BusForm from '/react4xp/parts/express-services-block/components/bus-form';
import CarForm from '/react4xp/parts/express-services-block/components/car-form';
import TruckForm from '/react4xp/parts/express-services-block/components/track-form';
import BusIcon from '/react4xp/parts/express-services-block/icons/bus-icon.svg';
import CarIcon from '/react4xp/parts/express-services-block/icons/car-icon.svg';
import TruckIcon from '/react4xp/parts/express-services-block/icons/truck-icon.svg';
import '/site/parts/express-services-block/express-services-block.scss';

const jsonToQueryString = (json: Record<string, any>) => {
    return Object.keys(json)
        .map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        })
        .join('&');
};

export const ExpressServicesBlock: FC = (props: any) => {
    const [truckType, setTruckType] = useState<string>();
    const [form] = Form.useForm();

    useEffect(() => {
        setTruckType(TRANSPORT_TYPES[0].value);
    }, []);

    const openUrl = (url: string) => {
        window.location.href = '/' + props.language + url;
    };

    const selectCarType = (item: string) => {
        setTruckType(item);
        form.resetFields();
    };

    const isSelected = (item: string): string => {
        return truckType === item ? 'selected' : '';
    };

    const calculate = () => {
        form.validateFields().then(() => {
            const values = form.getFieldsValue();
            values.year = dayjs(values.year).year();
            values.vehicleTypeId = truckType;

            window.location.href = `/${props.language}${props.config.url1}?${jsonToQueryString(
                values
            )}`;
        });
    };

    return (
        <div
            className="express-services-block hide-on-mobile"
            style={{
                height: 530,
                margin: 0,
            }}
        >
            <a
                href={props.language + props.config.urlList}
                className="express-services-block__title"
            >
                {localize('calculators', props.translations)}
            </a>
            <div className="express-services-block__body">
                <div className="express-services-block__body-1">
                    <Button
                        type="primary"
                        className="express-services-block__body-button selected"
                        onClick={() => openUrl(props.config.url1)}
                    >
                        {localize('transport-tax', props.translations)}
                    </Button>
                    <Button
                        type="primary"
                        className="express-services-block__body-button"
                        onClick={() => openUrl(props.config.url2)}
                    >
                        {localize('individual-income-tax', props.translations)}
                    </Button>
                    <Button
                        type="primary"
                        className="express-services-block__body-button"
                        onClick={() => openUrl(props.config.url3)}
                    >
                        {localize('print-form.penalty-calculation', props.translations)}
                    </Button>
                    <Button
                        type="primary"
                        className="express-services-block__body-button"
                        onClick={() => openUrl(props.config.url4)}
                    >
                        {localize('calculation-of-customs', props.translations)}
                    </Button>
                </div>

                <div className="express-services-block__body-2">
                    <Button
                        type="default"
                        className={`express-services-block__truck-button ${isSelected(
                            TRANSPORT_TYPES[0].value
                        )}`}
                        onClick={() => selectCarType(TRANSPORT_TYPES[0].value)}
                    >
                        <CarIcon />
                        <div>{localize('passenger-cars', props.translations)}</div>
                    </Button>
                </div>
                <div className="express-services-block__body-3">
                    <Button
                        type="default"
                        className={`express-services-block__truck-button ${isSelected(
                            TRANSPORT_TYPES[2].value
                        )}`}
                        onClick={() => selectCarType(TRANSPORT_TYPES[2].value)}
                    >
                        <BusIcon />
                        <div>
                            {localize('calc-transport-transport-types-buses', props.translations)}
                        </div>
                    </Button>
                </div>
                <div className="express-services-block__body-4">
                    <Button
                        type="default"
                        className={`express-services-block__truck-button ${isSelected(
                            TRANSPORT_TYPES[1].value
                        )}`}
                        onClick={() => selectCarType(TRANSPORT_TYPES[1].value)}
                    >
                        <TruckIcon />
                        <div>{localize('cargo', props.translations)}</div>
                    </Button>
                </div>

                <div className="express-services-block__body-5 mt-3">
                    <div className="express-services-block__volume">
                        {truckType === TRANSPORT_TYPES[0].value && (
                            <CarForm
                                translations={props.translations}
                                form={form}
                            />
                        )}
                        {truckType === TRANSPORT_TYPES[2].value && (
                            <BusForm
                                translations={props.translations}
                                form={form}
                            />
                        )}
                        {truckType === TRANSPORT_TYPES[1].value && (
                            <TruckForm
                                translations={props.translations}
                                form={form}
                            />
                        )}
                    </div>
                    <div className="express-services-block__body-6">
                        <Button
                            type="primary"
                            onClick={calculate}
                        >
                            {localize('button.calculate', props.translations)}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpressServicesBlock;
